import styled from 'styled-components';
import { layout, remCalc } from '@prisjakt/ui-base';

export const Header = styled.div`
  display: flex;
  margin-bottom: ${layout.spacing.large};
`;

export const Title = styled.h1`
  font-size: ${remCalc(36)};
  font-weight: normal;
  margin-bottom: ${layout.spacing.xSmall};
`;
